import React from 'react'

const AnnualReportIcon = ({props}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="currentColor"
        {...props}
    >
        <path 
            d="M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 
            22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 
            2.44405 3.44495 2 3.9934 2H16ZM11 7V17H13V7H11ZM15 
            11V17H17V11H15ZM7 13V17H9V13H7Z"
        ></path>
    </svg>
)

export default AnnualReportIcon
